export const Variables = {
  registerLink: "https://empresa.caju.com.br/classic/#/cadastro",
  stagingRegisterLink: "https://empresa-staging.caju.com.br/classic/#/cadastro",

  presentationLink: 'https://public-docs.caju.com.br/caju_apresentacao_comercial.pdf',
};
